/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchReadinessResponse } from './MatchReadinessResponse';
import {
    MatchReadinessResponseFromJSON,
    MatchReadinessResponseFromJSONTyped,
    MatchReadinessResponseToJSON,
    MatchReadinessResponseToJSONTyped,
} from './MatchReadinessResponse';
import type { CompetitionMatchStatus } from './CompetitionMatchStatus';
import {
    CompetitionMatchStatusFromJSON,
    CompetitionMatchStatusFromJSONTyped,
    CompetitionMatchStatusToJSON,
    CompetitionMatchStatusToJSONTyped,
} from './CompetitionMatchStatus';

/**
 * 
 * @export
 * @interface ReadyUpTeamResponse
 */
export interface ReadyUpTeamResponse {
    /**
     * 
     * @type {MatchReadinessResponse}
     * @memberof ReadyUpTeamResponse
     */
    readiness: MatchReadinessResponse;
    /**
     * 
     * @type {CompetitionMatchStatus}
     * @memberof ReadyUpTeamResponse
     */
    matchStatus: CompetitionMatchStatus;
}



/**
 * Check if a given object implements the ReadyUpTeamResponse interface.
 */
export function instanceOfReadyUpTeamResponse(value: object): value is ReadyUpTeamResponse {
    if (!('readiness' in value) || value['readiness'] === undefined) return false;
    if (!('matchStatus' in value) || value['matchStatus'] === undefined) return false;
    return true;
}

export function ReadyUpTeamResponseFromJSON(json: any): ReadyUpTeamResponse {
    return ReadyUpTeamResponseFromJSONTyped(json, false);
}

export function ReadyUpTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadyUpTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'readiness': MatchReadinessResponseFromJSON(json['readiness']),
        'matchStatus': CompetitionMatchStatusFromJSON(json['matchStatus']),
    };
}

export function ReadyUpTeamResponseToJSON(json: any): ReadyUpTeamResponse {
    return ReadyUpTeamResponseToJSONTyped(json, false);
}

export function ReadyUpTeamResponseToJSONTyped(value?: ReadyUpTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'readiness': MatchReadinessResponseToJSON(value['readiness']),
        'matchStatus': CompetitionMatchStatusToJSON(value['matchStatus']),
    };
}

